import { isString } from '../../helpers/is/index'
import { get, run } from '../../helpers/try/index'
import { isAkulakuIOS, isAkulakuAndroid } from '../is'

const root = global || window

if (isAkulakuIOS()) {
  /**
   * iOS 部分接口的回调设计有误，需要借助一个名为 Optional 的函数去执行 js 回调，此处做兼容实现
   */
  Object.assign(window, {
    Optional: command => {
      try {
        // eslint-disable-next-line
        eval(command)
      } catch (err) {
        console.error(
          `[模拟 Optional 错误] 第 1 兼容方案尝试执行的命令为：${command}`
        )
        console.error(err)
        console.warn('[模拟 Optional 错误] 将尝试第 2 兼容方案')
        return get(root, command)
      }
    }
  })
}
let uuid = 0
export const registerGlobalCallback  =  (
  callback,
  name,
  appVersion,
  throwaway = false
) => {
  appVersion = (appVersion && typeof appVersion === "string") ? appVersion : "";
  if (!name) {
    name = `__afterAction__${appVersion}`;
  } else {
    name = `__afterAction__${name}__${appVersion}`;
  }
  uuid++
  if (isString(callback)) {
    return callback
  }
  //调用当前函数 ...arg是app传递过来的对象
  root[name] = (jsonObj) => {
    if (typeof callback === 'function') {
      callback(jsonObj || {})
    }
    //清理全局变量 默认清理
    if (throwaway && root[name]) {
      delete root[name]
    }
  }

  return name
}

// export function getCurrentAppVersion() {
//   debugger
//     return isAkulakuAndroid() ? getAppVersionAndroid(): isAkulakuIOS() ? getAppVersionIOS(): "NO VERSION";
// }

/*版本号比较*/
export function compareVersion(v1, v2) {
  function parse(v) {
    return Number(
      v.replace(/[^\d.]/g, '')
        .split('.')
        .map((v, i) => '0'.repeat(3-v.length) + v)
        .join('')
    )
  }
  return parse(v1) >= parse(v2)
}
